/**
 * Centralized authentication utilities
 */

/**
 * Clears all authentication data from localStorage and notifies other tabs
 */
export const clearAuthData = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("isAuthenticated");
  
  // Trigger storage event to notify other tabs and the useAuth hook
  window.dispatchEvent(new StorageEvent('storage', {
    key: 'isAuthenticated',
    oldValue: 'true',
    newValue: null
  }));
};